export default "__VITE_ASSET__6ce1ebdc__"